<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M266,318h24V294H266Z" transform="translate(-266 -294)" fill="none"/><path d="M287.5,315l-4-4h-13a2.006,2.006,0,0,1-2-2V299a2.006,2.006,0,0,1,2-2h15a2,2,0,0,1,1.99,2Zm-17-16v10h13.83l1.17,1.17V299Z" transform="translate(-266 -294)"/></svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'reply'
}
</script>
